import React, { useEffect, useRef, useState } from "react";
import "./Review.css"; // Import the CSS file
import ReviewList from "./ReviewList/ReviewList";
import ReviewInvoiceView from "./ReviewInvoiceView/ReviewInvoiceView";
import { GetInvoicesService_NEW } from "../../../Services/InvoiceService/InvoiceService";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Loader from "../../../Components/Loader/Loader";
import RefreshBtn from "../../../Components/CustomButtons/RefreshBtn/RefreshBtn";
import SearchBtn from "../../../Components/CustomButtons/SearchBtn/SearchBtn";
import { reloadtabledata } from "../../../Reducer/AddInvoiceReducer";
import { InvoiceFieldMap } from "../../../Services/InvoiceService/constants";
import { updateInvoiceStage } from "../../../Services/StageUpdateService/StageUpdateApi";
import FilterBtn from "../../../Components/CustomButtons/FilterBtn/FilterBtn";
import ColumnSettings from "../../../Components/ColumnFilter/ColumnFilter";
import { useInvoiceActions } from "../../../hooks/useInvoiceActions";
import { InvoiceFilter } from "../../../Components/InvoiceFilter";
import { MdOutlineFilterAlt } from "react-icons/md";
import { IoSettingsSharp } from "react-icons/io5";
import AdvancedSearch from "../../../Components/InvoiceSearch/AdvancedSearch";
import { toInvoiceSearchPayload } from "../../../Components/InvoiceSearch/AdvanceType";
import { FiChevronDown, FiSearch } from "react-icons/fi";
import { InvoiceFilterFieldsPayload } from "../../../Components/InvoiceFilter/InvoiceFilter.fields";
import { ActiveFilterBar } from "../../../Components/InvoiceFilter/ActiveFilterBar";
import SelectedClientCard from "../../../Components/SelectedClientCard/SelectedClientCard";
import ToolsMenu, { BulkEditResult } from "../3Inbox/Tools/Toolsmenu"; // adjust path to where Toolsmenu really lives
import { BulkEditOptions } from "../3Inbox/BulkeditPopup/BulkEditPopup"; // keep the real folder casing
import {
  UpdateInvoiceFlagService,
  DeleteInvoice,
} from "../../../Services/InvoiceService/InvoiceService";
import AlertMessage from "../../../Components/AlertMessage/AlertMessage";


interface RowData {
  id: number;
  status: string;
  user: string;
  date: string;
  supplier: string;
  category: string;
  advanced: string;
  total: string;
  selected: boolean;
}

const Review: React.FC = () => {
  const dispatch = useDispatch();

  const selectedClient = useSelector((state: any) => state.selectedClient);
  var INVOICE_PER_FETCH = 100;
  //On OFF Invoice-List and Invoice-View
  const { makeInvoiceReady } = useInvoiceActions();
  const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [invoiceView, setInvoiceView] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  // const [cursor, setCursor] = useState<string>("");
  const [invoices, setInvoices] = useState<any[]>([]);
  const [failedView, setFailedView] = useState(false);

  const [isButtonActive, setIsButtonActive] = useState(false);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState<number[]>([]);

  const [data, setData] = useState<RowData[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(8);
  const recordsPerPage = 8;
  // const [dataSource, setDataSource] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  // State to control InvoiceFilter popup
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  // State to store active filter values
  const [activeFilters, setActiveFilters] = useState<any>(null);
  const [isOpenAdvance, setIsOpenAdvance] = useState(false);

  // --- Refs (not in state — updates must be instant, no re-render needed) ---
  const cursorRef = useRef<string>("");
  const sortKeyRef = useRef<keyof typeof InvoiceFieldMap | null>(null);
  const sortReverseRef = useRef<boolean>(false);
  // FIX: ref-based lock so rapid scroll events can't double-trigger
  const isLoadingMoreRef = useRef(false);
  const savedSort = localStorage.getItem("sortSettings");

  const [searchTerm, setSearchTerm] = useState("");
  const debounceRef = useRef<any>(null);

  const activeFiltersRef = useRef<any>(null);
  const activeAdvancedSearchRef = useRef<any>(null);

  const [fullinvoices, setFullInvoices] = useState<any[]>([]);

  const [activeAdvancedSearch, setActiveAdvancedSearch] = useState<any>(null);
  const advancedSearchRef = useRef<{ resetForm: () => void }>(null);
  interface SortState {
    // Ingaiye "null" ah add pannidunga
    key: keyof typeof InvoiceFieldMap | "default" | null;
    direction: boolean;
  }
  const [sortSettings, setSortSettings] = useState<SortState>({
    key: "default",
    direction: false,
  });
  // FIX: removed duplicate useEffect([]) — was calling FetchInvoices twice on mount
  useEffect(() => {
    if (selectedClient.selectedClient?.userId) {
      //  FetchData();
      FetchInvoices(false);
    }
  }, [selectedClient]);

  const pagereload = useSelector(
    (state: any) => state.dashboardFlag.reloadtabledata,
  );

  // Function to fetch invoice data from the server or service
  const FetchInvoices = async (
    loadMore = false,
    reverse: boolean = false,
    key: keyof typeof InvoiceFieldMap | null = null,

    filters: any = activeFilters, // Accept filters
    searchFields: any = null, // Accept search fields
    // cursorOverride: string | null = null,
    limit: number = INVOICE_PER_FETCH,

  ) => {
    if (!selectedClient.selectedClient?.userId) return;

    const apiSearchFields = toInvoiceSearchPayload(searchFields);

    try {
      if (!loadMore) setLoading(true); // only initial load

      const result = await GetInvoicesService_NEW({
        userId: selectedClient.selectedClient.userId,
        after: cursorRef.current || null,
        // FIX: use passed-in key/reverse params, not stale savedSort snapshot.
        // Falls back to savedSort only on initial load when key === null.
        order: key ?? (savedSort ? JSON.parse(savedSort).key : "default"),
        reversed: key !== null ? reverse : (savedSort ? JSON.parse(savedSort).direction : false),
        stageIds: [11, 12, 13],
        archiveStatuses: ["UnArchived", "Default"],
        limit: limit || INVOICE_PER_FETCH,

        searchFields: apiSearchFields,
        filterFields: filters || null,


      });

      if (result?.Items !== undefined) {
        setTotalInvoiceCount(result.TotalItem ?? 0);

        setInvoices((prev) => {
          if (!loadMore) return result.Items;

          const existingIds = new Set(prev.map((item) => item.id));

          const newItems = result.Items.filter(
            (item: any) => !existingIds.has(item.id)
          );

          return [...prev, ...newItems];
        });

        cursorRef.current = result.NextCursor || "";
        setHasMore(result.HasMore);
      }
      const fullresult = await GetInvoicesService_NEW({
        userId: selectedClient.selectedClient.userId,
        after: null, // <-- always null for full fetch
        order: key ?? (savedSort ? JSON.parse(savedSort).key : "default"),
        reversed:
          key !== null
            ? reverse
            : savedSort
              ? JSON.parse(savedSort).direction
              : false,
        stageIds: [11, 12, 13],
        archiveStatuses: ["UnArchived", "Default"],
        limit: result.TotalItem || totalInvoiceCount, // <-- FIX: use fresh result, not stale state
        filterFields: filters,
        searchFields: apiSearchFields,
      });
      setFullInvoices(fullresult?.Items || []);
      setFullInvoices(fullresult.Items);
    } catch (error) {
      console.error("Inbox fetch error:", error);
    } finally {
      if (!loadMore) setLoading(false);
    }
  };
  const sortInvoices = async (
    reverse: boolean,
    key: keyof typeof InvoiceFieldMap | null,
  ) => {
    // FIX: reset cursor + update sort refs before fetching sorted results
    cursorRef.current = "";
    sortKeyRef.current = key;
    sortReverseRef.current = reverse;

    const newSettings = { key, direction: reverse };
    setSortSettings(newSettings);
    localStorage.setItem("sortSettings", JSON.stringify(newSettings));

    // FIX: was calling resetAndFetch() (which calls FetchInvoices internally)
    // AND FetchInvoices again — double API call on every sort. Now single call.
    setSelectedInvoiceIds([]);
    setData([]);
    setSelectAll(false);
    await FetchInvoices(false, reverse, key);
  };

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);

    // reset cursor for new search
    cursorRef.current = "";

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      FetchInvoices(
        false,
        false,
        null,
        activeFilters,
        value ? { searchTerm: value } : null
      );
    }, 500); // 500ms delay
  };

  // FIX: use ref-based lock + sortReverseRef/sortKeyRef instead of stale savedSort
  const loadMoreInvoicesOnScroll = async () => {
    if (hasMore && !isLoadingMoreRef.current) {
      isLoadingMoreRef.current = true;
      setIsLoadingMore(true); // start loading
      await FetchInvoices(true, sortReverseRef.current, sortKeyRef.current, activeFiltersRef.current, activeAdvancedSearchRef.current);
      setIsLoadingMore(false);
      isLoadingMoreRef.current = false;
      dispatch(reloadtabledata(false));
      setLoading(false);
    }
    // Use this else part to send alert on reaching the end of list
    //else alert("nothing to fetch ");
  };
  const resetAndFetchforrefresh = async () => {
    setInvoices([]); // clear stale data
    //setCursor(""); // reset cursor
    cursorRef.current = "";
    setSelectedInvoiceIds([]); // clear selections (ID array)
    setData([]);

    setSelectAll(false); // Clear the select all button state
    setCurrentPage(1); // back to page 1
    await FetchInvoices(false, false, null, activeFilters, activeAdvancedSearch); // fresh fetch, no loadMore
  };

  const resetAndFetch = async () => {
    setInvoices([]);
    //setCursor(""); // reset cursor
    cursorRef.current = "";
    setSelectedInvoiceIds([]); // clear selections (ID array)
    setData([]);

    setSelectAll(false); // Clear the select all button state
    // setCurrentPage(1); // back to page 1
    await FetchInvoices(false, false, null, activeFilters, activeAdvancedSearch); // fresh fetch, no loadMore
  };

  useEffect(() => {
    if (selectedClient.selectedClient?.userId) {
      FetchInvoices(false, false, null, activeFilters);
    }
  }, [activeFilters]);

  useEffect(() => {
    activeFiltersRef.current = activeFilters;
  }, [activeFilters]);

  useEffect(() => {
    activeAdvancedSearchRef.current = activeAdvancedSearch;
  }, [activeAdvancedSearch]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    setIsButtonActive(selectedInvoiceIds.length > 0);
  }, [selectedInvoiceIds]);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord);

  const refreshInvoices = async () => {
    cursorRef.current = "";
    setHasMore(true);
    const sortDir = savedSort ? JSON.parse(savedSort).direction : false;
    const sortKey = savedSort ? JSON.parse(savedSort).key : null;
    await FetchInvoices(false, sortDir, sortKey, activeFilters, activeAdvancedSearch, invoices.length || 100);

  };

  // Logic to handle filter application
  const handleApplyFilters = (filterValues: any) => {
    cursorRef.current = "";
    sortKeyRef.current = null; // ← reset sort
    sortReverseRef.current = false;
    setInvoices([]);
    setActiveFilters(filterValues);
    setIsFilterPopupOpen(false);
    FetchInvoices(false, false, null, filterValues);
  };

  const bulkEditOptions: BulkEditOptions = {
    type: [], supplier: [], category: [], currency: [], paid: [],
    paymentMethod: []
  };

  // Refetch keeping filters/search/sort and the number of rows already loaded.
  // Setting loading=true unmounts ReviewList, which also resets its checkboxes.
  const refetchKeepingView = async () => {
    setFailedView(false);
    await resetAndFetchWithCount(invoices.length);
  };

  const handleFlag = async (ids: number[]) => {
    try {
      await Promise.all(ids.map((id) => UpdateInvoiceFlagService(id, true)));
      AlertMessage({ type: "success", text: "Invoice(s) flagged successfully" });
      await refetchKeepingView();
    } catch {
      AlertMessage({ type: "error", text: "Failed to flag invoice(s)" });
    }
  };

  const handleUnflag = async (ids: number[]) => {
    try {
      await Promise.all(ids.map((id) => UpdateInvoiceFlagService(id, false)));
      AlertMessage({ type: "success", text: "Invoice(s) unflagged successfully" });
      await refetchKeepingView();
    } catch {
      AlertMessage({ type: "error", text: "Failed to unflag invoice(s)" });
    }
  };

  const handleDelete = async (ids: number[]) => {
    try {
      await Promise.all(ids.map((id) => DeleteInvoice(id)));
      await refetchKeepingView();
    } catch {
      AlertMessage({ type: "error", text: "Failed to delete invoice(s)" });
    }
  };

  const handleMerge = async (sourceIds: number[], _mergedInvoiceId: number) => {
  try {
    await refetchKeepingView();
    AlertMessage({
      type: "success",
      text: `${sourceIds.length} invoices merged successfully`,
    });
  } catch {
    AlertMessage({ type: "error", text: "Failed to refresh after merge" });
  }
};

  const handleViewFailedItems = async (ids: number[]) => {
    try {
      const result = await GetInvoicesService_NEW({
        userId: selectedClient.selectedClient.userId,
        ids,
      } as any);
      setInvoices(result?.Items ?? []);
      setTotalInvoiceCount(result?.TotalItem ?? ids.length);
      setHasMore(false);
      cursorRef.current = "";
      setFailedView(true);
    } catch {
      AlertMessage({ type: "error", text: "Failed to load the failed items" });
    }
  };

  const handleBulkEditComplete = async (_result: BulkEditResult) => {
    await refetchKeepingView();
  };


  const resetAndFetchWithCount = async (count: number) => {
    setInvoices([]);
    cursorRef.current = "";
    setSelectedInvoiceIds([]);
    setData([]);
    setSelectAll(false);

    // Fetch enough rows to cover where the user was scrolled to
    const limitToFetch = Math.max(count, INVOICE_PER_FETCH);
    await FetchInvoices(false, sortReverseRef.current, sortKeyRef.current, activeFilters, activeAdvancedSearch, limitToFetch);
  };

  const moveToReady = async () => {
    if (selectedInvoiceIds.length === 0) return;

    const tableWrapper = document.querySelector('.table-wrapper') as HTMLElement;
    const savedScrollTop = tableWrapper ? tableWrapper.scrollTop : 0;

    // How many rows were loaded before the action?
    const previouslyLoadedCount = invoices.length;

    try {
      await makeInvoiceReady(selectedInvoiceIds, 21, "Default");
    } catch (error) {
      console.error("Move to ready failed", error);
    } finally {
      // Reset and reload enough rows to cover the previous scroll position
      await resetAndFetchWithCount(previouslyLoadedCount);

      setTimeout(() => {
        const wrapper = document.querySelector('.table-wrapper') as HTMLElement;
        if (wrapper) {
          wrapper.scrollTop = savedScrollTop;
        }
      }, 300);
    }
  };
  // --- Guards ---
  if (!selectedClient.selectedClient?.userId) {
    return <h1>Please select a client to view their invoices.</h1>;
  }

  //for active filter labels
  const handleAdvancedApply = (searchFields: any) => {
    setActiveAdvancedSearch(searchFields);
    cursorRef.current = "";
    FetchInvoices(false, false, null, activeFilters, toInvoiceSearchPayload(searchFields));
    setIsOpenAdvance(false);
  };

  const handleAdvancedReset = () => {
    setActiveAdvancedSearch(null);
    cursorRef.current = "";
    advancedSearchRef.current?.resetForm();
    FetchInvoices(false, false, null, activeFilters, null);
  };

  const handleRemoveFilter = (key: keyof InvoiceFilterFieldsPayload) => {
    const updated = { ...activeFilters, [key]: null };
    setActiveFilters(updated);
    setInvoices([]);
    setLoading(true);
    cursorRef.current = "";

  };

  const handleResetFilters = () => {
    setActiveFilters(null);
    setActiveAdvancedSearch(null);
    cursorRef.current = "";
    advancedSearchRef.current?.resetForm();
    setLoading(true);
    FetchInvoices(false, false, null, null, null);

  };
  const handleAdvancedRemove = (updated: any) => {
    setActiveAdvancedSearch(updated);
    cursorRef.current = "";
    setInvoices([]);
    FetchInvoices(false, false, null, activeFilters, toInvoiceSearchPayload(updated));
  };
  const hasActiveSearch = searchTerm || activeFilters ||
    (activeAdvancedSearch && Object.values(activeAdvancedSearch).some(v => v !== "" && v !== null));

  const isGenuinelyEmpty = invoices.length === 0 && !hasActiveSearch && !loading;
  const showToolbar = !isGenuinelyEmpty;

  return (
    <div>
      {invoiceView ? (
        <ReviewInvoiceView
          setInvoiceView={setInvoiceView}
          refreshInvoices={refreshInvoices}
          sortSettings={sortSettings}
          fullinvoices={fullinvoices}
          totalInvoiceCount={totalInvoiceCount}
        />
      ) : (
        <>
          <div className="selected-client-toolbar">
            <SelectedClientCard />
            {showToolbar && (
              <div className="selected-client-toolbar__actions">
                {/* <SearchBtn /> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "5px 8px", // inner spacing
                    width: "300px", // adjust width
                    background: "#fff",
                  }}
                >
                  {/* Search Icon */}
                  <FiSearch size={18} style={{ color: "#474646" }} />
                  {/* Input Field */}
                  <input
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    style={{
                      flex: 1,
                      border: "none",
                      outline: "none",
                      fontSize: "var(--font-size-base)",
                    }}
                  />

                  {/* Advanced Button */}
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenAdvance(true);
                      if (cursorRef.current) {
                        cursorRef.current = "";
                      }
                    }}
                    className="advanced-btn"
                  >
                    {/* <button
                  type="button"
                  onClick={() => setIsOpenAdvance(true)}
                  className="advanced-btn"
                > */}
                    Advanced
                    <FiChevronDown style={{ marginLeft: "4px" }} />
                  </button>
                </div>
                <AdvancedSearch
                  setIsOpenAdvance={isOpenAdvance}
                  onClose={() => setIsOpenAdvance(false)}
                  FetchInvoices={FetchInvoices}
                  onApply={handleAdvancedApply}
                  formRef={advancedSearchRef}
                  activeSearchFields={activeAdvancedSearch}
                />
                {isOpen && (
                  <ColumnSettings
                    isOpen={true}
                    onClose={() => setIsOpen(false)}
                  />
                )}
                {
                  <InvoiceFilter
                    activeFilters={activeFilters}
                    isOpen={isFilterPopupOpen}
                    onClose={() => setIsFilterPopupOpen(false)}
                    onApply={handleApplyFilters}

                  />
                }
                <FilterBtn
                  onClick={() => setIsFilterPopupOpen(true)}
                  disabled={loading}
                />
                <FilterBtn
                  onClick={() => setIsOpen(true)}
                  disabled={loading}
                  Icon={IoSettingsSharp}
                />
                {/* <RefreshBtn RefreshBtnClick={refreshInvoices} loading={loading} /> */}
              </div>
            )}
          </div>
          <div className="tm-row">
            <ToolsMenu
              selectedIds={selectedInvoiceIds}
              invoices={invoices}
              userId={selectedClient.selectedClient.userId}
              onMerge={handleMerge}
              onFlag={handleFlag}
              onUnflag={handleUnflag}
              onDelete={handleDelete}
              disabled={loading}
              screen="toReview"
              bulkEditOptions={bulkEditOptions}
              onBulkEditComplete={handleBulkEditComplete}
              onViewFailedItems={handleViewFailedItems}
            />
            <button
              className="tm-trigger"
              disabled={!isButtonActive}
              onClick={moveToReady}
            >
              Move to Ready
            </button>
            {failedView && (
              <span style={{ marginLeft: 12 }}>
                Showing items that could not be updated.{" "}
                <button type="button" onClick={refetchKeepingView}>Show all</button>
              </span>
            )}
          </div>
          {showToolbar && (
            <ActiveFilterBar
              activeFilters={activeFilters}
              activeAdvancedSearch={activeAdvancedSearch}
              onRemove={handleRemoveFilter}
              onReset={handleResetFilters}
              onAdvancedReset={handleAdvancedReset}
              onAdvancedRemove={handleAdvancedRemove}
            />
          )}
          {loading ? (
            <Loader />
          ) : invoices.length === 0 ? (
            <h1 style={{ textAlign: "center", marginTop: "40px", color: "#888" }}>
              No invoices found for this client
            </h1>
          ) : (
            <ReviewList
              loadMoreInvoicesOnScroll={loadMoreInvoicesOnScroll}
              setInvoiceView={setInvoiceView}
              invoicesDataSource={invoices} // this is correct
              totalInvoiceCount={totalInvoiceCount}
              isLoadingMore={isLoadingMore}
              sortInvoices={sortInvoices}
              onSelectionChange={setSelectedInvoiceIds}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Review;
